import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Redirect, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import Component from 'BaseComponent';
import Backend from 'components/Backend';
import Login from 'components/Login';
import RequestPasswordReset from 'components/RequestPasswordReset';
import ResetPassword from 'components/ResetPassword';
import CompleteAccountAttivation from 'components/CompleteAccountAttivation';
import WpLogin from 'components/WpLogin';
import Register from 'components/Register';
import Maintenance from 'components/Maintenance';
import ConfirmationSent from 'components/ConfirmationSent';
import Notifications from 'components/Notifications';

@connect(state => ({
  token: state.session.accessToken,
}))

export default class App extends Component {
  static propTypes = {
    token: PropTypes.string,
  }

  renderLoggedRoutes() {
    return (
      <Switch>
        <Route path="/:slug/wp-login" component={WpLogin} />
        <Route path="/maintenance" component={Maintenance} />
        <Route path="/" component={Backend} />
        <Redirect to="/" />
      </Switch>
    );
  }

  renderNonLoggedRoutes() {
    return (
      <Switch>
        <Route path="/:slug/wp-login" component={WpLogin} />
        <Redirect exact from="/" to="/login" />
        <Route exact path="/login" component={Login} />
        <Route exact path="/request_password_reset" component={RequestPasswordReset} />
        <Route exact path="/reset_password/:token" component={ResetPassword} />
        <Route exact path="/complete_account_attivation/:token" component={CompleteAccountAttivation} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/confirmation_sent" component={ConfirmationSent} />
        <Route exact path="/maintenance" component={Maintenance} />
        <Redirect to="/login" />
      </Switch>
    );
  }

  render() {
    return (
      <div>
        <Notifications />
        <BrowserRouter>
          {
            this.props.token ?
              this.renderLoggedRoutes() :
              this.renderNonLoggedRoutes()
          }
        </BrowserRouter>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/App.jsx